import type { IconName } from './icon.glyphs';

/** Figma `Icon` 세트(Foundations, 2015:414)의 size 축. xs 12 · sm 16 · md 20 · lg 24 · xl 32 */
export const ICON_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export type IconSize = (typeof ICON_SIZES)[number];

export const ICON_SIZE_CLASS: Record<IconSize, string> = {
  xs: 'size-(--size-icon-xs)',
  sm: 'size-(--size-icon-sm)',
  md: 'size-(--size-icon-md)',
  lg: 'size-(--size-icon-lg)',
  xl: 'size-(--size-icon-xl)',
};

/** 선 굵기(화면 px). 크기와 상관없이 같다 — Figma 인스턴스도 크기를 바꿔도 1.5 (DD-17 I4). 예외는 glyph 의 strokeWidth(plus-thin 0.75, DD-23 3) */
export const ICON_STROKE_WIDTH = 1.5;

/** 통계 카드 전용 아이콘. 24px(lg) 이상에서만 쓴다 — 16px 에서는 뭉개진다 (DD-17 I8) */
export type StatIconName = Extract<IconName, `stat-${string}`>;
/** 글자 라벨이 있는 파일 유형 아이콘. 20px(md) 이상에서만 쓴다 — 16px 에서는 라벨을 읽을 수 없다 (DD-17 I3) */
export type FileTypeIconName = Extract<
  IconName,
  'file-doc' | 'file-xls' | 'file-ppt' | 'file-pdf' | 'file-img' | 'file-etc'
>;

/** 크기 제한이 없는 아이콘(xs ~ xl). 이름을 맵으로 고르는 곳의 값 타입으로 쓴다 */
export type GeneralIconName = Exclude<IconName, StatIconName | FileTypeIconName>;

/** 아이콘마다 쓸 수 있는 가장 작은 크기(없으면 xs 부터). 타입(`IconProps`)과 확인 페이지가 함께 쓴다 */
export const ICON_MIN_SIZE: Partial<Record<IconName, IconSize>> = {
  'file-doc': 'md',
  'file-xls': 'md',
  'file-ppt': 'md',
  'file-pdf': 'md',
  'file-img': 'md',
  'file-etc': 'md',
  'stat-company': 'lg',
  'stat-multiple': 'lg',
  'stat-employee': 'lg',
  'stat-investable': 'lg',
  'stat-fund-volume': 'lg',
  'stat-celebrate': 'lg',
  'stat-presentation': 'lg',
  'stat-aum': 'lg',
  'stat-invest-total': 'lg',
  'stat-exit': 'lg',
  'stat-valuation': 'lg',
};
